import useSWR from "swr";

import { messagingEndpoint, type MessagingStatusResponse } from "@/api/client";
import { API_BASE_URL } from "@/lib/env";

export function useMessaging(enabled = true) {
  const { data, error, isLoading, mutate } = useSWR<MessagingStatusResponse>(
    enabled ? messagingEndpoint(API_BASE_URL) : null,
  );

  return {
    messagingStatus: data ?? null,
    isLoading: enabled && isLoading,
    isError: Boolean(error),
    refreshMessaging: mutate,
  };
}
